import { carouselData } from '@/mocks/homeData';

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="section-container">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950">
            热门专题
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500">
            精选影视专题合集，发现更多精彩内容
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {carouselData.slice(0, 3).map((item) => (
            <div
              key={item.id}
              className="group relative bg-background-50 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-500/30 transition-all duration-300 cursor-pointer"
            >
              <div className="relative aspect-[2/1] overflow-hidden bg-background-200">
                <img
                  src={item.cover}
                  alt={item.title}
                  title={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  width="960"
                  height="480"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-50 via-transparent to-transparent"></div>
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-4 md:p-5">
                <span className="text-[11px] bg-accent-500/90 text-background-50 px-2 py-0.5 rounded-md font-medium">
                  {item.tag}
                </span>
                <h3 className="mt-2 text-base md:text-lg font-heading font-bold text-foreground-950 line-clamp-1">
                  {item.title}
                </h3>
                <p className="mt-1 text-xs md:text-sm text-foreground-600 line-clamp-2">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-5 md:mt-6 grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
          {carouselData.slice(3, 5).map((item) => (
            <div
              key={item.id}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-500/30 transition-all duration-300 cursor-pointer flex flex-col sm:flex-row"
            >
              <div className="relative sm:w-[200px] lg:w-[240px] aspect-[2/1] sm:aspect-auto overflow-hidden bg-background-200 flex-shrink-0">
                <img
                  src={item.cover}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  width="960"
                  height="480"
                />
              </div>
              <div className="p-4 md:p-5 flex flex-col justify-center">
                <span className="text-[11px] bg-secondary-100/80 text-secondary-700 px-2 py-0.5 rounded-md font-medium w-fit">
                  {item.tag}
                </span>
                <h3 className="mt-2 text-sm md:text-base font-heading font-bold text-foreground-900">
                  {item.title}
                </h3>
                <p className="mt-1 text-xs md:text-sm text-foreground-500 line-clamp-2">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}